import React, { FC } from 'react';
import { IBaseComponent } from '~/sharedInterfaces/IBaseComponent';

export interface IText {
  text?: string;
}

interface ITextProps extends IText, IBaseComponent {}

const Text: FC<ITextProps> = ({ text }) => {
  return (
    <div className="qred-component qred-text">
      <p>{text}</p>
    </div>
  );
};

export default Text;
